import React from 'react';
import { FaRocket, FaExternalLinkAlt, FaChessKnight } from 'react-icons/fa';
import { BsCodeSlash } from 'react-icons/bs';
import { RiArticleLine } from 'react-icons/ri';

const getIcon = (type) => {
    switch(type) {
        case 'research': return <FaRocket />;
        case 'project': return <BsCodeSlash />;
        case 'chess': return <FaChessKnight />;
        case 'blog': return <RiArticleLine />;
        default: return <RiArticleLine />;
    }
};

const formatType = (type) => {
    return type.charAt(0).toUpperCase() + type.slice(1);
};

function Post({ post, style }) {
    const { type, title, date, content, component, skills, image, link, linkText } = post;
    
    return (
        <div className="post-container" style={style}>
            <div className="post-header">
                <div className="post-meta">
                    <span className="post-type-icon">{getIcon(type)}</span>
                    <span className="post-type-label">{formatType(type)}</span>
                    <span className="post-date">{date}</span>
                </div>
                <h2 className="post-title">{title}</h2>
            </div>
            
            <div className="post-body">
                {image && (
                    <div className="post-image-wrap">
                        <img src={image} alt={title} className="post-image" />
                    </div>
                )}
                
                {content && <div className="post-content">{content}</div>}
                
                {component && <div className="post-component">{component}</div>}
            </div>
            
            {(skills && skills.length > 0) && (
                <div className="post-footer">
                    <div className="skills">
                        {skills.map(item => <div className="skill-item" key={item}>{item}</div>)}
                    </div>
                </div>
            )}
            
            {link && (
                <div className="post-link-wrap">
                    <a href={link} className="hero-link" target="_blank" rel="noreferrer">
                        {linkText || 'Read More'} <FaExternalLinkAlt style={{marginLeft: "5px", fontSize: "10px"}} />
                    </a>
                </div>
            )}
        </div>
    );
}

export default Post;
